
































import { Component, Vue, Prop } from "vue-property-decorator";
import {
  ProductInstanceResult,
  INSTANCE_CLUSTER,
  INSTANCE_COMPANY,
  INSTANCE_OWNERSHIP_ENTITY
} from "@futuri/cloudsso-client/src/client/types/productInstances";
import { Action, Getter } from "vuex-class";
import { getInstanceCompany } from "@futuri/cloudsso-client/src/instanceUtils";
import { ProductType } from "@futuri/cloudsso-client/src/client/types/productType";

@Component
export default class ClusterBar extends Vue {
  @Getter("email")
  email?: string;

  // @Getter('availableInstances')
  // instances?: ProductInstanceResult[]
  @Prop()
  instances?: ProductInstanceResult[];

  @Getter("currentProduct", { namespace: "session" })
  currentProduct?: ProductType;

  @Getter("currentClusterInstanceId", { namespace: "session" })
  currentClusterInstanceId?: string;

  @Action("setCurrentClusterInstanceId", { namespace: "session" })
  setCurrentClusterInstanceId!: (id?: string) => void;

  get clusterInstances() {
    console.log("getting cluster instances");
    const productInstances = this.instances?.filter(
      inst => !this.currentProduct || inst.product === this.currentProduct
    );
    return productInstances?.filter(inst => {
      const companiesToInclude = new Set(["iHeartMedia", "Alpha Media"]);
      // const company = getInstanceCompany(inst)
      // const includeCompany = companiesToInclude.has(company)
      const includeCompany = true;
      if (includeCompany) {
        // Include companies in dropdown before their clusters
        return (
          inst.instanceType === INSTANCE_COMPANY ||
          inst.instanceType === INSTANCE_OWNERSHIP_ENTITY ||
          inst.instanceType === INSTANCE_CLUSTER
        );
      }

      return inst.instanceType === INSTANCE_CLUSTER;
    });
  }

  get defaultClusterObject() {
    const click = (id?: string) => (_event: MouseEvent) => {
      console.log("Setting selected instance to: ", id);
      this.setCurrentClusterInstanceId(id);
    };

    return { name: "(All Clusters)", value: "all", onClick: click("all") };
  }

  get displayClusters() {
    console.log("getting displayClusters");
    const click = (id?: string) => (_event: MouseEvent) => {
      console.log("Setting selected instance to: ", id);
      this.setCurrentClusterInstanceId(id);
    };

    const instanceClusters =
      this.clusterInstances?.map(inst => {
        const { name, instanceId } = inst;
        return {
          name: `${name}`,
          value: instanceId,
          onClick: click(instanceId)
        };
      }) ?? [];

    const all = this.defaultClusterObject;
    return [all].concat(instanceClusters);
  }

  get currentCluster() {
    const instances = this.clusterInstances ?? [];
    const selected = this.currentClusterInstanceId;

    if (!selected || selected === "all") {
      return this.defaultClusterObject;
    }
    return instances.filter(inst => inst.instanceId === selected)[0];
  }

  get currentClusterName() {
    return this.currentCluster?.name;
  }

  // For search

  @Action("setSearchPrefix", { namespace: "session" })
  setSearchPrefix!: (prefix: string) => Promise<void>;

  get searchCaption() {
    const routePath = this.$route.fullPath;
    if (routePath.match(/\/users\//)) {
      return "Search by username, email address, or first or last name.";
    } else {
      return "Search by station, cluster, or company name.";
    }
  }

  // Replace when we update uikit
  connectSearch() {
    this.$nextTick(() => {
      const searchBar = this.$refs.searchBar as any;
      const cards = this.$refs.cards as any;

      if (searchBar) {
        searchBar.onSearch = (query: string) => {
          console.log("query: ", query);

          cards.submitSearch(query);
        };

        // cards.productType = view.productType

        const inputEl = searchBar?.shadowRoot?.querySelector("input");
        let prev = "";
        inputEl?.addEventListener("keyup", (e: KeyboardEvent) => {
          const val = inputEl.value;
          // if (e.keyCode === 13) {
          //   cards.submitSearch(val)
          //   e.preventDefault()
          //   return
          // }

          if (val !== prev) {
            console.log("fayt: ", val);
            // cards.productType = view.productType
            // cards.filterQuery = val.length ? val : undefined
            // view.filterQuery = val.length ? val : undefined
            this.setSearchPrefix(val);
          }
          prev = val;
        });
      }
    });
  }

  mounted() {
    this.connectSearch();
  }

  // Actions

  logout() {
    console.log("logout");
  }
}
